import type { CategoryCardModel } from '@/features/catalog/api';

import { CategoryCard } from './CategoryCard';

export function CategoryGrid({ categories }: { categories: CategoryCardModel[] }) {
  return (
    <div className="category-grid">
      {categories.map((category) => (
        <CategoryCard category={category} key={category.slug} />
      ))}
    </div>
  );
}
